import { render, staticRenderFns } from "./OnlineBroadcastBlock.vue?vue&type=template&id=b7be26b0&scoped=true&"
import script from "./OnlineBroadcastBlock.vue?vue&type=script&lang=js&"
export * from "./OnlineBroadcastBlock.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBroadcastBlock.vue?vue&type=style&index=0&id=b7be26b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7be26b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7be26b0')) {
      api.createRecord('b7be26b0', component.options)
    } else {
      api.reload('b7be26b0', component.options)
    }
    module.hot.accept("./OnlineBroadcastBlock.vue?vue&type=template&id=b7be26b0&scoped=true&", function () {
      api.rerender('b7be26b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/OnlineBroadcastBlock.vue"
export default component.exports